import toast from 'react-hot-toast';
import { getRetryInfo, isApiBlocked } from './apiRetry';

const notificationShown = new Map();
const NOTIFICATION_COOLDOWN = 60000; // 1 minute

export const showApiErrorNotification = (apiKey, errorType) => {
  const now = Date.now();
  const lastShown = notificationShown.get(apiKey);
  
  if (lastShown && (now - lastShown) < NOTIFICATION_COOLDOWN) {
    return;
  }
  
  const retryInfo = getRetryInfo(apiKey);
  const blocked = isApiBlocked(apiKey);
  
  if (blocked && retryInfo) {
    const blockUntil = retryInfo.blockUntil || (retryInfo.lastAttempt + 120000);
    const remainingTime = Math.ceil((blockUntil - now) / 1000);
    
    let message = '';
    
    switch (errorType) {
      case 'NETWORK_ERROR':
        message = `Cannot connect to server. Please check your connection. Retrying in ${Math.ceil(remainingTime / 60)} minute(s).`;
        break;
      case 'SERVER_ERROR':
        message = `Server is currently unavailable. Please try again in ${Math.ceil(remainingTime / 60)} minute(s).`;
        break;
      case 'MAX_RETRIES_EXCEEDED':
        message = `Maximum retry attempts reached. Please try again in ${Math.ceil(remainingTime / 60)} minute(s).`;
        break;
      default:
        message = `Service temporarily unavailable. Please try again later.`;
    }
    
    toast.error(message, {
      duration: 5000,
      id: `api-error-${apiKey}`,
    });
    
    notificationShown.set(apiKey, now);
  }
};

export const clearApiErrorNotifications = () => {
  notificationShown.clear();
};
